module.exports = "/assets/data/07012fa429d9ae6363fefe992c3e6145-NE99.data.json";